export enum TransactionType {
  LEGACY = 0,
  // EIP2930 = 1, Not support yet
  EIP1559 = 2,
}
